import { IConsentActivity } from "../../reports/types/reports.types";

export enum FormType {
    RELEASE_OF_INFORMATION = "release_of_information",
}

export enum FormStatus {
    NOT_SENT = "not_sent",
    SENT = "sent",
    RECEIVED = "received",
    NEEDS_CORRECTION = "needs_correction",
    COMPLETED = "completed",
    RECEIVED_RENEWAL = "received_renewal",
    RENEWAL_SENT = "renewal_sent",
    NO_LONGER_NEEDED = "no_longer_needed",
    FOLLOW_UPS_COMPLETED = "follow_ups_completed",
}

export enum FormSource {
    INTAKE = "intake",
    MANTLE = "mantle",
}

export interface IClientFormRecord {
    form_id: string;
    client_id: string;
    session_id?: string;
    practice_id: string;
    form_type?: FormType;
    form_source: string;
    status: string;
    start_date: string;
    end_date: string;
    form_content: { authorized_users: string[] };
    document_links: string[];
    activity_log: IConsentActivity[];
    signed_at: string;
    client_submitted_at: string;
    created_by: string;
    updated_by: string;
    created_at: string;
    updated_at: string;
}

export interface IAddClientFormRecord {
    form_type: FormType;
    form_source?: string;
    status?: string;
    start_date: string;
    end_date: string;
    session_id?: string;
    form_content: {
        authorized_users: string[];
        purpose?: string;
    };
    signed_at: string;
}
export interface IFormDocument {
    document_id: string;
    document_url: string;
    document_name: string;
    uploaded_by: string;
    content_type: string;
    uploaded_at: string;
}

export interface IFormActivity {
    activity_id: string;
    timestamp: string;
    user_id: string;
    user_name: string;
    activity_type: string;
    description: string;
    metadata?: Record<string, unknown>;
}

export interface IAddClientFormPayload {
    client_id: string;
    form_type: string;
    start_date: string;
    end_date: string;
    form_source?: string;
    status?: string;
    session_id?: string;
    form_content?: Record<string, unknown>;
    authorized_recipients?: string;
    signed_at?: string;
    client_submitted_at?: string;
}

export interface IUpdateClientFormPayload {
    status?: FormStatus;
    start_date?: string;
    end_date?: string;
    signed_at?: string | null;
    client_submitted_at?: string;
    activity_note?: string;
}

export interface IClientForm {
    form_id: string;
    client_id: string;
    session_id: string | null;
    practice_id: string;
    form_type: FormType;
    form_source: FormSource;
    status: FormStatus | null;
    start_date: string;
    end_date: string;
    form_content: Record<string, unknown>;
    document_links: IFormDocument[];
    activity_log: IFormActivity[];
    signed_at: string | null;
    client_submitted_at: string | null;
    created_by: string;
    updated_by: string | null;
    created_at: string;
    updated_at: string;
    client_first_name: string;
    client_last_name: string;
    client_email: string;
    primary_assignee?: {
        user_id: string;
        first_name: string;
        last_name: string;
    };
    secondary_assignee?: {
        user_id: string;
        first_name: string;
        last_name: string;
    };
}

export interface IClientFormFilters {
    search_string?: string;
    client_id?: string;
    form_type?: FormType;
    status?: FormStatus;
    start_date_from?: string;
    start_date_to?: string;
    page?: number;
    limit?: number;
    order_by?: string;
}
